var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[(_vm.data)?_c('ReanalyzeView',{attrs:{"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }